import { styled } from "@mui/system";
import { FONT_SIZE_MD, FONT_WEIGHT_NORMAL, FONT_SIZE_CUSTOM_LG } from "../config/styles";
import { colors } from "../config/colors";

export const InfoValue = styled("span")(({ statusColor }) => ({
  fontSize: FONT_SIZE_MD,
  fontFamily: "Open Sans, sans-serif",
  fontWeight: FONT_WEIGHT_NORMAL,
  lineHeight: FONT_SIZE_CUSTOM_LG,
  color: statusColor || colors.custom,
}));
